export default __webpack_public_path__ + "static/media/orders-dark-green.27b219c2.svg";